import { KeyboardCode } from '@dnd-kit/core';

const directions = [KeyboardCode.Right, KeyboardCode.Left];
const sequenceKeyboardCoordinates = (event, {
  context: {
    active,
    droppableRects,
    droppableContainers
  }
}) => {
  if (!directions.includes(event.code)) {
    return;
  }
  event.preventDefault();
  const collisionRect = droppableContainers.get(active?.id)?.rect.current;
  if (!active || !collisionRect) {
    return;
  }
  const droppableContainerRects = droppableContainers.getEnabled().map(it => ({
    ...it,
    rect: {
      current: droppableRects.get(it.id) ?? null
    }
  })).filter(it => it && !it.disabled && it.id !== active.id && !!it.rect.current);
  const rectsBefore = droppableContainerRects.filter(it => collisionRect.top - it.rect.current.top > 5);
  const rectsOnSameLine = droppableContainerRects.filter(it => Math.abs(it.rect.current.top - collisionRect.top) < 5);
  const rectsAfter = droppableContainerRects.filter(it => collisionRect.top - it.rect.current.top < -5);
  switch (event.code) {
    case KeyboardCode.Left:
      {
        const rectsOnSameLineBeforeCurrent = rectsOnSameLine.filter(it => it.rect.current.right < collisionRect.left);
        if (rectsOnSameLineBeforeCurrent.length) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const nextRect = rectsOnSameLineBeforeCurrent.sort((a, b) => b.rect.current.left - a.rect.current.left)[0];
          return {
            x: nextRect.rect.current.left,
            y: nextRect.rect.current.top
          };
        } else if (rectsBefore.length) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const nextRect = rectsBefore.sort((a, b) => {
            if (a.rect.current.top === b.rect.current.top) {
              return b.rect.current.left - a.rect.current.left;
            } else {
              return b.rect.current.top - a.rect.current.top;
            }
          })[0];
          return {
            x: nextRect.rect.current.left,
            y: nextRect.rect.current.top
          };
        }
        return undefined;
      }
    case KeyboardCode.Right:
      {
        const rectsOnSameLineBeforeCurrent = rectsOnSameLine.filter(it => it.rect.current.left > collisionRect.right);
        if (rectsOnSameLineBeforeCurrent.length) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const nextRect = rectsOnSameLineBeforeCurrent.sort((a, b) => a.rect.current.left - b.rect.current.left)[0];
          return {
            x: nextRect.rect.current.left,
            y: nextRect.rect.current.top
          };
        } else if (rectsAfter.length) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const nextRect = rectsAfter.sort((a, b) => {
            if (a.rect.current.top === b.rect.current.top) {
              return a.rect.current.left - b.rect.current.left;
            } else {
              return a.rect.current.top - b.rect.current.top;
            }
          })[0];
          return {
            x: nextRect.rect.current.left,
            y: nextRect.rect.current.top
          };
        }
        return undefined;
      }
  }
};

export { sequenceKeyboardCoordinates };
//# sourceMappingURL=util.keyboard-coordinates.js.map
